"use client";
// components/Nav.jsx
import { useState } from "react";
import Link from "next/link";

export default function Nav() {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <nav style={{
      display: "flex", alignItems: "center", justifyContent: "space-between",
      padding: "12px 20px", background: "#fff", borderBottom: "2px solid #fde68a",
      position: "sticky", top: 0, zIndex: 100,
      boxShadow: "0 2px 8px rgba(251,191,36,0.12)",
    }}>
      {/* Logo */}
      <Link
          href="/"
          style={{
            display: "flex",
            alignItems: "center",
            gap: 10,
            textDecoration: "none",
          }}
        >
          <div style={{
            width: 38,
            height: 38,
            borderRadius: 10,
            flexShrink: 0,
            background: "linear-gradient(135deg, #f97316, #fbbf24)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: 20,
            boxShadow: "0 3px 0 #ca8a04",
          }}>
            📋
          </div>

          <div>
            <div style={{
              fontSize: 20,
              fontWeight: 900,
              color: "#dc2626",
              letterSpacing: "-0.5px",
              lineHeight: 1.1,
            }}>
              #ClearTheList
            </div>

            <div style={{
              fontSize: 10,
              fontWeight: 700,
              color: "#f97316",
              textTransform: "uppercase",
            }}>
              For Teachers
            </div>
          </div>
        </Link>

      {/* Desktop links */}
      <div className="hidden md:flex items-center gap-3">
        <Link href="/#how-it-works" style={{fontSize: 14,fontWeight: 600,color: "#64748b",textDecoration: "none"}}>
          How it Works
        </Link>
        <Link href="/#map" style={{ fontSize: 14, fontWeight: 600, color: "#64748b", textDecoration: "none",}}>
          Support a Classroom
        </Link>
        <Link href="/registration">
          <button className="bg-amber-400 hover:bg-amber-500 text-amber-950 font-bold py-2 px-5 rounded-full shadow-[0_4px_0_0_#ca8a04] active:translate-y-1 active:shadow-none transition-all" style={{ whiteSpace: "nowrap" }}>
            Submit a List ✏️
          </button>
        </Link>
      </div>

      {/* Mobile: Submit button + hamburger */}
      <div className="flex md:hidden items-center gap-2">
        {/* <Link href="/registration">
          <button style={{
            background: "#fbbf24", color: "#7c2d12", fontWeight: 800, fontSize: 12,
            padding: "8px 14px", borderRadius: 999, border: "none", cursor: "pointer",
            boxShadow: "0 3px 0 #ca8a04", whiteSpace: "nowrap",
          }}>
            Submit a List✏️
          </button>
        </Link> */}
        <button
          onClick={() => setMenuOpen(o => !o)}
          style={{
            width: 36, height: 36, borderRadius: 8, border: "2px solid #fde68a",
            background: "#fff9e6", cursor: "pointer", fontSize: 18,
            alignItems: "center", justifyContent: "center",
          }}
        >
          {menuOpen ? "✕" : "☰"}
        </button>
      </div>

      {/* Mobile dropdown menu */}
      {menuOpen && (
        <div style={{
          position: "absolute", top: "100%", left: 0, right: 0,
          background: "#fff", borderBottom: "2px solid #fde68a",
          boxShadow: "0 8px 24px rgba(0,0,0,0.1)",
          display: "flex", flexDirection: "column", padding: "12px 20px 16px", gap: 12,
          zIndex: 99,
        }}>
          <Link href="/#how-it-works" onClick={() => setMenuOpen(false)}
            style={{
              fontSize: 15,
              fontWeight: 700,
              color: "#1e293b",
              textDecoration: "none",
              padding: "8px 0",
              borderBottom: "1px solid #fde68a",
            }}
          >
            ✨ How it Works
          </Link>
          <Link
            href="/#map"
            onClick={() => setMenuOpen(false)}
            style={{
              fontSize: 15,
              fontWeight: 700,
              color: "#1e293b",
              textDecoration: "none",
              padding: "8px 0",
              borderBottom: "1px solid #fde68a",
            }}
          >
            🗺️ Support a Classroom
          </Link>
          <Link href="/registration" onClick={() => setMenuOpen(false)}>
            <button style={{
              width: "100%", background: "#fbbf24", color: "#7c2d12", fontWeight: 800,
              fontSize: 15, padding: "12px", borderRadius: 12, border: "none", cursor: "pointer",
              boxShadow: "0 4px 0 #ca8a04",
            }}>
              Submit a List ✏️
            </button>
          </Link>
        </div>
      )}

      {/* <style>{`
        .desktop-nav { display: flex; }
        .mobile-nav  { display: none; }
        @media (max-width: 640px) {
          .desktop-nav { display: none; }
          .mobile-nav  { display: flex; }
        }
      `}</style> */}
    </nav>
  );
}